export default {"src":"/_next/static/media/ra-aircraft-airport-fill.32cfc36d.svg","height":22,"width":61,"blurWidth":0,"blurHeight":0};